const homeCopy = {
  boxCopy1: 'BY LINCOLN RETAILERS. ',
  boxCopy2: 'FOR LINCOLN RETAILERS.',
  subHeaderTitle: 'NEW & NOTEWORTHY',
};

export default homeCopy;
